import executeServerApi from 'assets/utils/server/ServerApi';
import { getDefaultHeaders, HttpMethod } from 'config/Api.Config';

type Request = Api.Finance.ContractRefundPayment.Save.IRequest;
type Response = Api.Finance.ContractRefundPayment.Save.IResponse;
type Headers = Api.Finance.ContractRefundPayment.Save.IHeaders;
const url = '/api/Finance/ContractRefundPayment';
export default async function contractRefundPaymentSaveApi(body?: Request): Promise<Api.Res<Response>> {
  return await executeServerApi<Request, Response, Headers>({
    method: HttpMethod.post,
    url,
    body,
    headers: getDefaultHeaders(),
  });
}
